module.exports = __webpack_public_path__ + "static/img/12.38908b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/12.png
// module id = iT7i
// module chunks = 0